import React from "react";
import { Droplets, Sun, Layers } from "lucide-react";

const blocks = [
  {
    icon: Layers,
    title: "Prémium bútorszövetek",
    desc: "Kizárólag kiváló minőségű bútorszövetekkel dolgozunk, köztük vízzel tisztítható, teflonos bevonatú anyagokkal, amelyek egyszerre elegánsak, tartósak és könnyen tisztíthatók.",
    accent: true,
  },
  {
    icon: Sun,
    title: "Kültéri UV-álló szövetek",
    desc: "Kerti bútorok párnázatához UV-stabil, időjárásálló szövetek — évek múlva is megőrzik a színüket és a tartásukat.",
  },
  {
    icon: Droplets,
    title: "Vízzel tisztítható felület",
    desc: "Teflonos bevonatú bútorszövetek éttermekbe, kávézókba, családi otthonokba — a foltok egyszerű törléssel eltávolíthatók.",
  },
];

export default function Materials() {
  return (
    <section
      id="anyagok"
      data-testid="materials-section"
      className="velvet-cream py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="md:col-span-6">
            <div className="overline mb-6 flex items-center">
              <span className="gold-rule" />
              Anyagok
            </div>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-[#0A1228]">
              A megfelelő szövet
              <span className="italic text-[#1E47A8]"> mindent eldönt.</span>
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-base md:text-lg text-[#4A5468] leading-relaxed font-light">
              A bútor élettartamát elsősorban a felhasznált anyag határozza meg.
              Ezért csak megbízható, iparilag bevizsgált szövetekkel dolgozunk.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {blocks.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={i}
                data-testid={`material-block-${i}`}
                className={
                  b.accent
                    ? "relative bg-[#0A1228] text-[#F5F2EC] p-8 md:p-10 md:row-span-1 md:col-span-3 lg:col-span-1 lg:row-span-1"
                    : "relative bg-[#FBF9F4] border border-[#0A1228]/10 p-8 md:p-10"
                }
              >
                <div
                  className={
                    "w-11 h-11 flex items-center justify-center rounded-full mb-6 " +
                    (b.accent
                      ? "bg-[#D4B47A]/15 border border-[#D4B47A]/40"
                      : "bg-[#0A1228]/5 border border-[#0A1228]/10")
                  }
                >
                  <Icon
                    size={20}
                    className={b.accent ? "text-[#D4B47A]" : "text-[#1E47A8]"}
                    strokeWidth={1.5}
                  />
                </div>
                <h3
                  className={
                    "font-serif-display text-2xl md:text-3xl leading-tight mb-4 " +
                    (b.accent ? "text-[#F5F2EC]" : "text-[#0A1228]")
                  }
                >
                  {b.title}
                </h3>
                <p
                  className={
                    "text-[15px] leading-relaxed font-light " +
                    (b.accent ? "text-[#F5F2EC]/80" : "text-[#4A5468]")
                  }
                >
                  {b.desc}
                </p>
                {b.accent && (
                  <div className="absolute top-8 right-8 text-[10px] tracking-[0.3em] uppercase text-[#D4B47A]">
                    Ajánlott
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
